import { render, staticRenderFns } from "./secKill.vue?vue&type=template&id=64b34a7e&scoped=true"
import script from "./secKill.vue?vue&type=script&lang=js"
export * from "./secKill.vue?vue&type=script&lang=js"
import style0 from "./secKill.vue?vue&type=style&index=0&id=64b34a7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b34a7e",
  null
  
)

export default component.exports